import { motion } from 'motion/react';
import type { ReactNode } from 'react';

import { duration, easing, revealViewport } from './tokens';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: duration.section, ease: easing.entrance } },
};

/**
 * A grid/list whose children animate in one after another as it scrolls into
 * view. Pair with StaggerItem on each child. Reduced-motion keeps the fade only.
 */
export function StaggerGroup({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <motion.div
      className={className}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={revealViewport}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <motion.div className={className} variants={item}>
      {children}
    </motion.div>
  );
}
